import $ from "jquery";

var scheduleNotificationHide;

$(scheduleNotificationHide);

scheduleNotificationHide = function () {
  setTimeout(hideNotification, 15000);
};

window.hideNotification = function (className) {
  if (className == null) {
    className =
      '.alert:not(".alert-info, .tc-alert__info, .no-close"), .alert.__sticky';
  }
  $($.find(className)).fadeOut("slow", function () {
    $(this).remove();
  });
};

window.showNotification = function (message, className) {
  var $notification, flash, onClickHandler, timerId;
  if (className == null) {
    className = "error";
  }
  timerId = null;
  $notification = null;
  hideNotification(".alert.__sticky");
  onClickHandler = function () {
    if ($notification) {
      $notification.remove();
    }
    if (timerId) {
      return clearTimeout(timerId);
    }
  };
  $(".tc-alert__" + className).remove();
  flash =
    "<div class='alert tc-alert__" +
    className +
    "'>\n<div class='tc-alert--body'>" +
    message +
    "</div>\n</div>";
  $notification = $(flash);
  $("body").prepend($notification);
  $notification.off("click", onClickHandler).on("click", onClickHandler);
  timerId = scheduleNotificationHide();
};
